import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useUserDataContext } from '../../contexts/userDataProvider';
import { usePropertyContext } from '../../contexts/propertyProvider';

const PropertyList = ({ setData, timeLineSelectedElementId }) => {
  const { data } = usePropertyContext();
  const { translate } = useUserDataContext();
  const [selectedElement, setSelectedElement] = useState();

  const handlePropertySelect = (id, title, costPerNight) => {
    setSelectedElement(id);
    setData({
      propertyName: title,
      propertyId: id,
      costPerNight: costPerNight
    })
  };

  // Select  property on edit
  useEffect(() => {
    if (timeLineSelectedElementId) {
      setSelectedElement(timeLineSelectedElementId);
    }
  }, [timeLineSelectedElementId]);

  return (
    <>
      <div className={'property-list-wrap'}>
        {data?.length === 0 ? (
          <div className="nothing-found">{translate('addFirstPropertyInSettings')}</div>
        ): (
          data?.map(({ id, title, costPerNight, isAvailable }) => (
            <div
              key={id}
              className={`property-item ${!isAvailable ? 'disabledGroup' : ''}`}
              onClick={() => handlePropertySelect(id, title, costPerNight)}
            >
              {!isAvailable && (<p className="disabled-message">{translate('disabledInSettings')}</p>)}
              <div
                title={title}
                className={`selectable-area ${
                  selectedElement === id || timeLineSelectedElementId === id ? 'selected' : ''
                }`}
              ></div>
              <div
                className={`content ${
                  selectedElement === id || timeLineSelectedElementId === id ? 'selected-content' : ''
                }`}
              >
                <div className="item-wrap">
                  <p className="title">{translate('title')}:</p>
                  <p className="value">{ title }</p>
                </div>
                <div className="item-wrap">
                  <p className="title">{translate('costNight')}:</p>
                  <p className="value">{ costPerNight }</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

PropertyList.propTypes = {
  setData: PropTypes.func.isRequired,
  timeLineSelectedElementId: PropTypes.string
};

export default PropertyList;
